
const PersonListModel = function (){
    const name = 'PersonList';
    return {
        name,
        state:{
            condition:{
                name:'',
                status:'',
            },
            newModal:{
                id:'',
                mchNo:'',
                name:'',
                mobile:'',
                email:'',
                sex:'',
                address:'',
                phone2:'',
                status:'',
                groupId:'',
                password:'123456',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            }
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_CONDITION',
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_NEW_MODAL',
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_LIST',
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_PAGE',
                    page
                })
            }
        },
        reducers:{
            condition:(state = PersonListModel.state.condition, action) => {
                if(action.type === 'CHANGE_CONDITION'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = PersonListModel.state.newModal, action) => {
                if(action.type === 'CHANGE_NEW_MODAL'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = PersonListModel.state.page, action) => {
                if(action.type === 'CHANGE_PAGE'){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = PersonListModel.state.list , action ) => {
                if(action.type === 'CHANGE_LIST'){
                    return [ ...action.list ];
                };
                return state;
            }
        }
    }
}();

export default PersonListModel;


// WEBPACK FOOTER //
// ./src/models/PersonManageModel.js